import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import 'react-image-lightbox/style.css';
import './assets/base.scss';
import './common.css';
import App from './app';
import configureStore from './config/configureStore';
import { Provider } from 'react-redux';

export const store = configureStore();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <HashRouter>
      <App />
    </HashRouter>
  </Provider>
);

